/*--------------------------------------
 Replace all SVG images with inline SVG
 --------------------------------------*/
SVG = {
    init: function () {
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });


    }

};


/*-------------------------
         SLIDERS
 ------------------------*/
SwiperAddresses = {
    init: function () {
        new Swiper('.swiper__addresses', {
            loop: true, speed: 600, slidesPerView: 1, spaceBetween: 0, breakpoints: {
                769: {
                    loop: true, slidesPerView: 2, grabCursor: true, allowTouchMove: true, spaceBetween: 30,
                }
            }

        });
    }
};

SwiperCategories = {
    init: function () {
        new Swiper('.swiper__categories', {
            slidesPerView: 'auto',
            speed: 600,
            loop: false,
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            freeMode: {
                enabled: false,
                sticky: true,
                momentumBounce: false

            },
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                "1435": {
                    allowTouchMove: false,
                }
            }
        });

        //INITIAL
        if ($(window).width() >= 1435) {
            $(".swiper__categories img").on('dragstart', function () {
                return false
            })

            $('.swiper__categories a').on('pointerdown',
                function pointerHandler(event) {
                    window.location.href = $(this).attr('href');
                }
            );
        }

    }
};


/*-------------------------
         FAQs
 ------------------------*/
AccordionFAQS = {
    init: function () {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;

                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }
};


/*-------------------------
         MENÚ
 ------------------------*/
Menu = {
    init: function () {
        /*  --  MEGAMENÚ DESKTOP  --  */
        //OBRIR MENÚ
        $(".header__burger").click(function () {
            $("body").addClass("menu-open");
        });

        //TANCAR
        $("body").click(function (event) {
            if (!$(event.target).closest('.section-menu, .header__burger').length) {
                $("body").removeClass("menu-open");
            }
        });
        $(".menu-head__close-btn").click(function () {
            $("body").removeClass("menu-open");
        });

        //OPEN SEARCH
        $(".header__search").click(function () {
            $("body").addClass("open-search-mobile");
            setTimeout(function () {
                $(".input-search-mobile").focus();
            }, 300);
        });

        $(".header-search-mobile__close").click(function () {
            $("body").removeClass("open-search-mobile");
        });


        //DESACTIVAR ARRASTRE IMATGES/ICONES (a header)
        $("header img, header svg").on('dragstart', function () {
            return false
        });

        //MENU DESKTOP
        $(".menu-categories__link").mouseenter(function () {
            $('.menu-categories__link').not(this).removeClass('submenu-open')
            $("body").removeClass("megamenu-open");
            $(this).addClass("submenu-open");
            if ($(this).hasClass("megamenu-btn")) {
                $("body").addClass("megamenu-open");
            }

        });

        $("main").mouseenter(function (event) {
            if (!$(event.target).closest('.menu-categories__link').length) {
                $(".menu-categories__link").removeClass("submenu-open");
                $("body").removeClass("megamenu-open");
            }
        });
        $("#shopify-section-footer").mouseenter(function (event) {
            $(".menu-categories__link").removeClass("submenu-open");
            $("body").removeClass("megamenu-open");
        });

        $(".header__content").mouseenter(function () {
            $(".menu-categories__link").removeClass("submenu-open");
            $("body").removeClass("megamenu-open");
        });

        $(".layer-blur").mouseenter(function () {
            $(".menu-categories__link").removeClass("submenu-open");
            $("body").removeClass("megamenu-open");
        });

        $(".menu-categories__link").mouseenter(function () {
            $(".menu-categories__link__a", this).addClass("link-active-top-hover");
            $(".link-active-top").css("border-bottom", "2px solid transparent")
        });
        $(".menu-categories__link").mouseleave(function () {
            $(".menu-categories__link__a", this).removeClass("link-active-top-hover");
            $(".link-active-top").css("border-bottom", "2px solid #111111")

        });

        /* SEARCH DESKTOP */
        $(".button-search").click(function () {
            $(".header-search").addClass("header-search-open");
            $("body").addClass("search-open");
            setTimeout(function () {
                $(".input-search").focus();
                $(".header-search").css("top", "0");
            }, 200);

        });

        $(".header-search__close").click(function () {
            $(".list-top-search").hide();
            $(".header-search__input").hide();
            $(".header-search____logo").hide();
            $(".header-search__close").hide();
            $(".header-search").removeClass("header-search-open");
            $("body").removeClass("search-open");
            setTimeout(function () {
                $("body.announcement-bar-open .header-search").css("top", "40px");
                $(".list-top-search").show();
                $(".header-search__input").show();
                $(".header-search____logo").show();
                $(".header-search__close").show();
            }, 200);
        });

        //clicked on the "body", but not inside of .menu-categories__children
        $("body").click(function (event) {
            if (!$(event.target).closest('.header-search, .button-search').length) {
                $(".list-top-search").hide();
                $(".header-search__input").hide();
                $(".header-search____logo").hide();
                $(".header-search__close").hide();
                $(".header-search").removeClass("header-search-open");
                $("body").removeClass("search-open");
                setTimeout(function () {
                    $("body.announcement-bar-open .header-search").css("top", "40px");
                    $(".list-top-search").show();
                    $(".header-search__input").show();
                    $(".header-search____logo").show();
                    $(".header-search__close").show();
                }, 200);
            }
        });




        /*  --  SUBMENÚ MÒBIL  --  */
        //OBRIR
        $(".submenu-btn").click(function (event) {
            event.preventDefault();
            var index = $(this).data('id');
            $("body").addClass("header-submenu-open")
            $(".submenu-" + index).addClass("open");
        });

        //TENCAR
        $(".submenu__item .back-btn svg").click(function () {
            var index = $(this).data('id');
            $("body").removeClass("header-submenu-open")
            $(".submenu__item").removeClass("open");
        });

        /*  --  VH FUNCTION  --  */
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        /*  --  CONFIGURAR ALÇADES  --  
        //Set wrapper height same as absolute child element (menú mobile)
        $(".section-menu .menu-categories").height($(".section-menu .menu-categories-list").height());

        //IF screen height is bigger than menu content (menú mobile)
        
        if ($(window).innerHeight() > $(".menu-content").height() + $(".menu-head").outerHeight()) {
            $(".menu-content").height($(window).innerHeight() - $(".menu-head").outerHeight());
        }
        */
    }
};

/*-------------------------
REGISTER ACCEPTANCE
 ------------------------*/
RegisterAcceptance = {
    init: function (ev) {
        /*
        $("#create_customer button").click(function (ev) {
            if ($("#acceptance-check").not(':checked').length || $("#acceptance-check-alt").not(':checked').length) {
                ev.preventDefault();
                location.reload();
            }
        });
        */
        var inputsFull = false;

        checkInput();

        $("#acceptance-check, #acceptance-check-alt").click(function () {
            checkRequired();
            checkInput();
        })

        $("#button-disabled").click(function (ev) {
            ev.preventDefault();
        })

        $("#button-disabled").mouseenter(function () {
            $('#acceptance-check, #acceptance-check-alt').addClass("missed-input");
            $("input:empty").addClass("missed-input");
        });

        $("#button-disabled").mouseleave(function () {
            $('#acceptance-check, #acceptance-check-alt').removeClass("missed-input");
            $("input:empty").removeClass("missed-input");
        });

        $("#button-enabled").mouseenter(function () {
            $("input:empty").addClass("missed-input");
        });

        $("#button-enabled").mouseleave(function () {
            $("input:empty").removeClass("missed-input");
        });

        $('#create_customer input.required').on('input', function (e) {
            checkRequired();
            checkInput();
        });

        function checkRequired() {
            console.log("hello");
            var errors = 0;
            $("#create_customer input.required").map(function () {
                if (!$(this).val()) {
                    errors++;
                    //console.log("empty");
                }
            });

            if (errors == 0) {
                inputsFull = true;
            } else {
                inputsFull = false;
            }
        }

        function checkInput() {
            if ($("#acceptance-check, #acceptance-check-alt").is(":checked") && inputsFull) {
                $("#button-disabled").hide();
                $("#button-enabled").show();
                $('#create_customer').bind('submit', function (e) { e.preventDefault(); });
            } else {
                $("#button-disabled").show();
                $("#button-enabled").hide();
                $('#create_customer').unbind('submit');
            }
        }
    }
};

/*-------------------------
      HEADQUARTERS TEL
 ------------------------*/
HeadquartersTel = {
    init: function () {
        $(".addresses__info a").map(function () {
            if ($(this).attr("href").split(":")[0] == "tel") {
                $(this).addClass("tel-icon");
            }
        });
    }
};

/*-------------------------
       REVIEWS POPUP
 ------------------------*/
ReviewsPopup = {
    init: function () {
        if ($("body").hasClass("product")) {
            $("body").click(function () {
                if ($(".reviews-wrapper .spr-form").css('display') != 'none') {
                    $(".layer-review-bg").addClass("active");
                } else {
                    $(".layer-review-bg").removeClass("active");
                }
            });
        }
    }
};

/*-------------------------
       RECOVER PWD
 ------------------------*/
RecoverPwd = {
    init: function () {
        $(".recover_pwd-btn").click(function () {
            $(".login__content").addClass("hide-register");
        });

        $(".recover-cancel").click(function () {
            $(".login__content").removeClass("hide-register");
        });
    }
};

$(function () {
    console.log('%cGassiot & Llobet', 'color:blue');
    RecoverPwd.init();
    ReviewsPopup.init();
    HeadquartersTel.init();
    RegisterAcceptance.init();
    SwiperAddresses.init();
    SwiperCategories.init();
    AccordionFAQS.init();
    Menu.init();
    SVG.init();
    if (typeof lastproduct === 'undefined') {
    } else {
        RecentProduct.save(lastproduct);
    }

    $('.accordion input').on('change', function () {
        $('.accordion input').not(this).prop('checked', false);
    });

    $("body").animate({ opacity: 1 }, 200);

    $("img.lazy").Lazy();


    //LEGAL NEWSLETTER FOOTER
    $(".submit-layer").mouseover(function () {
        $(this).closest("#mc_embed_signup_scroll").addClass("hover-button");
    });

    $(".submit-layer").mouseleave(function () {
        $(this).closest("#mc_embed_signup_scroll").removeClass("hover-button");
    });




    $(".form__newsletter .submit-layer").click(function (e) {
        $(".form__newsletter .newsletter-legal").addClass("no-accept");
    });


    $(".form__newsletter input#legal_news").change(function () {
        if (this.checked) {
            $(".form__newsletter .newsletter-legal").removeClass("no-accept");
            $(".form__newsletter .submit-layer").hide();
        } else {
            $(".form__newsletter .submit-layer").show();
        }
    });


    //LEGAL NEWSLETTER POPUP
    $(".popup__content__text__form .submit-layer").click(function (e) {
        $(".popup__content__text__form .newsletter-legal").addClass("no-accept");
    });
    $(".popup__content__text__form input#legal_news").change(function () {
        if (this.checked) {
            $(".popup__content__text__form .newsletter-legal").removeClass("no-accept");
            $(".popup__content__text__form .submit-layer").hide();
        } else {
            $(".popup__content__text__form .submit-layer").show();
        }
    });


    //LEGAL NEWSLETTER BANNER
    $(".newsletter__form .submit-layer").click(function (e) {
        $(".newsletter__form .newsletter-legal").addClass("no-accept");
    });



    $(".newsletter__form input#legal_news").change(function () {
        if (this.checked) {
            $(".newsletter__form .newsletter-legal").removeClass("no-accept");
            $(".newsletter__form .submit-layer").hide();
        } else {
            $(".newsletter__form .submit-layer").show();
        }
    });
});


/*-------------------------
   SAVE in cookie the recents –> 
   RecentProduct.save('13524533','hadle-tes','test');
   RecentProduct.get();
   RecentProduct.buildlist();
 ------------------------*/
RecentProduct = {
    init: function () {
    },
    save: function (lastproduct) {
        var recentProducts = this.get();

        recentProducts.unshift(lastproduct);
        recentProducts = recentProducts.slice(0, 5);   // aseguramos que la lista no tenga más de 10 elementos
        recentProducts = this.multiDimensionalUnique(recentProducts);
        var productosSerializados = JSON.stringify(recentProducts); // Serializamos el array a una cadena de texto
        document.cookie = "productosVistos=" + productosSerializados; // Creamos una cookie con el array serializado
    },
    get: function () {
        // Leemos la cookie con el array serializado
        var productosSerializados = getCookie("productosVistos");
        // Deserializamos la cadena de texto a un array
        if (productosSerializados.length > 0) {
            var productos = JSON.parse(productosSerializados);
        } else {
            return [];
        }

        if (productos[0] === "") { // si no hay ningún producto en la lista, devolvemos una lista vacía
            return [];
        }

        return productos;
    },
    multiDimensionalUnique: function (arr) {
        var uniques = [];
        var itemsFound = {};
        for (var i = 0, l = arr.length; i < l; i++) {
            var stringified = JSON.stringify(arr[i]);
            if (itemsFound[stringified]) { continue; }
            uniques.push(arr[i]);
            itemsFound[stringified] = true;
        }
        return uniques;
    },
    buildlist: function () {
        var recentProducts = this.get();
        recentProducts.forEach(function (valor, index, array) {
            console.log(index + ' title>' + array[index][2] + ' handle>' + array[index][1]);
        });
    }
};

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return "";
}